<div
  class="d-flex align-items-center gap-2 px-3 py-3 offcanvas-header border-bottom border-dashed"
>
  <h3 class="pageheader">
    <i class="ti ti-settings fs-3" style="font-size: 16px !important"></i>&nbsp;
    Profile Settings
  </h3>

  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="offcanvas"
    aria-label="Close"
    (click)="offcanvas.dismiss('')"
  ></button>
</div>

<ngx-simplebar
  class="offcanvas-body p-0 h-100"
  style="overflow-x: hidden !important"
  data-simplebar
>
  <div class="p-2">
    <div class="row">
      <div class="col-2">        
          <ng-container *ngIf="this.userSettings.userInfo.imagePath; else avatarTemplate">
            <img [src]="this.userSettings.userInfo.imagePath" alt="user-image"
              class="rounded-circle me-lg-2 d-flex user-avatar-img" />
          </ng-container>
          <ng-template #avatarTemplate>
            <div class="rounded-circle me-lg-2 d-flex user-avatar-initials">
              {{ getInitials(this.userSettings.userInfo.first_name,this.userSettings.userInfo.last_name) }}
            </div>
          </ng-template>
      </div>
      <div class="col-5">
        <a
          class="topbar-link drop-arrow-none px-2 p-2"
          type="button"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <span class="d-lg-flex flex-column gap-1 d-none">
            <h5 class="my-0">
              {{ this.userSettings.userInfo.first_name }}
              {{ this.userSettings.userInfo.last_name }}
            </h5>
            <h6 class="my-0 fw-normal">
              {{ this.userSettings.userInfo.email }}
            </h6>
          </span>
        </a>
      </div>
      <div class="col-4"></div>
      <div class="col-1">
        <div class="action-buttons ">
          <button
            (click)="openModal($event, profilesettingmodal, { centered: true })"
            data-bs-target="#profilesettingmodal"
            class="btn edit-btn rounded-circle"
            title="Edit"
          >
            <i class="ti ti-settings fs-25"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="p-1 border-bottom border-dashed">
    <div class="row">
      <div id="handle-dragula-left" class="cardContainer" dragula="HANDLE">
        <app-profilesettingcard
          *ngFor="let item of profileSettingData"
          [isShow]="isCardVisible(item)"
          [imageSource]="item.imageSource"
          [cardTitle]="item.cardTitle"
          [cardDescription]="item.cardDescription"
          [isActive]="userType == item.isActive"
          (onCardClick)="cardEvent(item)"
        />
      </div>
    </div>
  </div>
  <!-- <div class="p-2 border-bottom border-dashed">
    <h3 class="pageheader">Notifications</h3>

    <div class="row">
      <app-checkbox
        title="Email Notification"
        [formGroup]="profile"
        formControlValue="notification"
      />
      <p class="checkboxlabel d-block">
        You will be notified when a new email arrives.
      </p>
    </div>
    <div class="row">
      <app-checkbox
        title="Sound Notification"
        [formGroup]="profile"
        formControlValue="message"
      />
      <p class="checkboxlabel">
        You will be notified with sound when someone messages you.
      </p>
    </div>
  </div> -->
</ngx-simplebar>

<div class="d-flex align-items-center gap-2 px-3 py-2 offcanvas-header">
  <!-- <button type="button" class="btn btnlogout" (click)="openModal($event,logoutmodal, { centered: true })" data-bs-target="#logoutmodal" >
  <i class="ti ti-logout"></i>&nbsp; Log Out </button> -->
  <button type="button" class="btn btnlogout" (click)="confirmAction()">
    <i class="ti ti-logout"></i>&nbsp; Log Out
  </button>
  <button
    type="button"
    class="btn btnchangepassword"
    (click)="openModal($event, centermodal, { centered: true })"
    data-bs-target="#centermodal"
  >
    Change Password
  </button>
</div>

<ng-template
  #centermodal
  let-modal
  class="modal fade"
  id="centermodal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <app-update-password (modalDismiss)="handleModalDismiss()" />
</ng-template>

<ng-template
  #logoutmodal
  let-modal
  class="modal fade"
  id="logoutmodal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <app-log-out (modalDismiss)="handleModalDismiss()" />
</ng-template>

<ng-template
  #profilesettingmodal
  let-modal
  class="modal fade fixWidth"
  id="profilesettingmodal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <app-profile-setting-modal (modalDismiss)="handleModalDismiss()" />
</ng-template>
